import React, { Component } from 'react';
import { ModalHeader, Modal, ModalBody, Button, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import PropTypes from 'prop-types';

import { LoginContext } from "../../../components/ParadigmaLoginProvider";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			password: "",
			errorMsg:"",
			disabled: false,
		};
		this.username = React.createRef();
		this.password = React.createRef();
	}


	static propTypes = {
		open: PropTypes.bool,
		onClose: PropTypes.func,
		onLogin: PropTypes.func,
	}

	canLogin() {
		const { username, password } = this.state;
		if (username === "") { this.username.focus(); return false; }
		if (password === "") { this.password.focus(); return false; }
		return true;
	}

	render() {
		const { open, onClose } = this.props;
		const { username, password, disabled, errorMsg } = this.state;
		return (
			<LoginContext.Consumer>
				{({ logged, login, errorMsg }) => {
					return <Modal size="md" isOpen={open} toggle={() => (onClose ? onClose() : null)}>
						<ModalHeader className="px-4">
							Ingresá a tu cuenta
						</ModalHeader>
						<ModalBody className="px-4">
							<form
								onSubmit={() => {
									if (this.canLogin()) {
										login(username, password, (result) => {
											if (result) this.setState({ username: "", password: "", });
											if (result && onClose) onClose();
										})
									}
									return false;
								}}
								autocomplete="on"
							>
								<InputGroup className="mb-3">
									<InputGroupAddon addonType="prepend">
										<InputGroupText>
											<i className="icon-envelope"></i>
										</InputGroupText>
									</InputGroupAddon>
									<Input
										ref={(input) => this.username = input}
										disabled={disabled} value={username}
										onKeyDown={(e) => {
											if (e.keyCode === 13 && this.canLogin()) {
												login(username, password, (result) => {
													if (result) this.setState({ username: "", password: "", });
													if (result && onClose) onClose();
												})
											}
										}}
										onChange={(e) => this.setState({ username: e.target.value })}
									type="text" placeholder="Email" autoComplete="on" />
								</InputGroup>
								<InputGroup className="mb-4">
									<InputGroupAddon addonType="prepend">
										<InputGroupText>
											<i className="icon-lock"></i>
										</InputGroupText>
									</InputGroupAddon>
									<Input
										ref={(input) => this.password = input}
										disabled={disabled} value={password}
										onKeyDown={(e) => {
											if (e.keyCode === 13 && this.canLogin()) {
												login(username, password, (result) => {
													if (result) this.setState({ username: "", password: "", });
													if (result && onClose) onClose();
												})
											}
										}}
										onChange={(e) => this.setState({ password: e.target.value })}
									type="password" placeholder="Contraseña" autoComplete="on" />
								</InputGroup>
								<h6 className={".text-warning"}>{errorMsg}</h6>
								<Row>
									<Col sm={4} className="mx-auto">
										<Button
											disabled={!(username !== "" && password !== "") || disabled}
											color="primary" className="px-4 py-2 w-100"
											type="submit"
										>
											{disabled && <i className={"fa fa-refresh fa-refresh-animated"}></i>}
										INGRESAR</Button>
									</Col>
								</Row>
							</form>
						</ModalBody>
					</Modal>;
				}}
			</LoginContext.Consumer>
					);
				}
			}

			export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js